module.exports = __webpack_public_path__ + "static/img/dynamicsBox.bacf7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/dynamicsBox.png
// module id = J0uX
// module chunks = 0